"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealerService = void 0;
class DealerService {
    constructor(dealerClient) {
        this.dealerClient = dealerClient;
    }
    async getServicePartners(vin, isWCar, brand, query) {
        return await this.dealerClient.getServicePartners(vin, isWCar, brand, query);
    }
    async getServicePartner(isWCar, brand, partnerNumber, country) {
        const response = await this.dealerClient.getServicePartner(isWCar, brand, partnerNumber, country);
        return response.dealers[0];
    }
}
exports.DealerService = DealerService;
//# sourceMappingURL=DealerService.js.map